import {
  CameraFilled,
  CheckOutlined,
  FolderOpenOutlined,
  LineOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { Col, Row, Image, Button } from "antd";
import "../App.css";

import podoBase from "../images/podo_base.png";
import TestUI, { TestUIStim } from "./TestUI";
import { PosturalExamination, PosturalTestDefinition } from "./interfaces";
import { photoNotTakenYet, TakenPhoto } from "./PosturalExamWrapper";
import { useEffect, useRef, useState } from "react";

const PosturalExamPodoStim_TakePhotos = ({
  images,
  getWebcamPhoto,
  loadPhoto,
}: {
  images: TakenPhoto[];
  getWebcamPhoto: Function;
  loadPhoto: Function;
}) => {
  const ref1 = useRef<any>();
  //For Responsive

  const [width, setWidth] = useState(0);
  const handleResize = () => setWidth(window.innerWidth);

  useEffect(() => {
    //mount
    window.addEventListener("resize", handleResize);
    setWidth(window.innerWidth);
    //unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      {width > 640 && (
        <div className="centered" style={{ width: "64%" }}>
          <Row>
            <Col span={1} />
            <Col span={22}>
              <div>
                <Image
                  style={{
                    borderRadius: "25px",
                  }}
                  fallback={podoBase}
                  preview={
                    images.length >= 1 && images[0].url != photoNotTakenYet.url
                  }
                  src={(images.length >= 1 && images[0].url) || podoBase}
                />
              </div>
              <Button
                style={{
                  color: "white",
                }}
                onClick={() => getWebcamPhoto(0)}
              >
                <CameraFilled rev={undefined} />
              </Button>
              <Button
                style={{
                  color: "white",
                }}
                onClick={() => ref1.current?.click()}
              >
                <input
                  type={"file"}
                  accept={"image/*"}
                  style={{ display: "none" }}
                  ref={ref1}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e && e.target && e.target.files)
                      loadPhoto(0, e.target.files[0]);
                  }}
                />
                <FolderOpenOutlined rev={undefined} />
              </Button>
              <Button
                disabled={true}
                style={{
                  background:
                    images.length >= 1 && images[0].url != photoNotTakenYet.url
                      ? images[0].uploaded
                        ? "#9edcc4"
                        : "#598f7a"
                      : "#a785a9",
                  color: "white",
                  cursor: "default",
                }}
              >
                {images.length >= 1 && images[0].url != photoNotTakenYet.url ? (
                  images[0].uploaded ? (
                    <CheckOutlined rev={undefined} />
                  ) : (
                    <LoadingOutlined rev={undefined} />
                  )
                ) : (
                  <LineOutlined rev={undefined} />
                )}
              </Button>
            </Col>
            <Col span={1} />
          </Row>
        </div>
      )}
      {width <= 640 && (
        <div className="centrados" style={{ width: "64%" }}>
          <Row>
            <Col span={1} />
            <Col span={22}>
              <div>
                <Image
                  style={{
                    borderRadius: "25px",
                  }}
                  fallback={podoBase}
                  preview={
                    images.length >= 1 && images[0].url != photoNotTakenYet.url
                  }
                  src={(images.length >= 1 && images[0].url) || podoBase}
                />
              </div>

              <Button
                style={{
                  color: "white",
                }}
                onClick={() => ref1.current?.click()}
              >
                <input
                  type={"file"}
                  accept={"image/*"}
                  style={{ display: "none" }}
                  ref={ref1}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e && e.target && e.target.files)
                      loadPhoto(0, e.target.files[0]);
                  }}
                />
                <CameraFilled rev={undefined} />
              </Button>
              <Button
                disabled={true}
                style={{
                  background:
                    images.length >= 1 && images[0].url != photoNotTakenYet.url
                      ? images[0].uploaded
                        ? "#9edcc4"
                        : "#598f7a"
                      : "#a785a9",
                  color: "white",
                  cursor: "default",
                }}
              >
                {images.length >= 1 && images[0].url != photoNotTakenYet.url ? (
                  images[0].uploaded ? (
                    <CheckOutlined rev={undefined} />
                  ) : (
                    <LoadingOutlined rev={undefined} />
                  )
                ) : (
                  <LineOutlined rev={undefined} />
                )}
              </Button>
            </Col>
            <Col span={1} />
          </Row>
        </div>
      )}
    </>
  );
};

const PosturalExamPodoStimRight = ({
  page,
  images,
  getWebcamPhoto,
  loadPhoto,
  testDefinitions,
  posturalExamination,
  setTestSelection,
}: {
  page: number;
  images: TakenPhoto[];
  getWebcamPhoto: Function;
  loadPhoto: Function;
  testDefinitions: PosturalTestDefinition[];
  posturalExamination: PosturalExamination;
  setTestSelection: Function;
}) => {
  if (testDefinitions && testDefinitions.length > 0)
    testDefinitions.sort((td1, td2) => td1.id - td2.id);

  return (
    <>
      {page == 0 && (
        <PosturalExamPodoStim_TakePhotos
          loadPhoto={loadPhoto}
          images={images}
          getWebcamPhoto={getWebcamPhoto}
        />
      )}
      {page == 1 && (
        <>
          <Row>
            <Col span={24}>
              {testDefinitions.length > 0 && (
                <TestUI
                  testDefinition={
                    testDefinitions.length > 0 ? testDefinitions[0] : undefined
                  }
                  testSelection={
                    posturalExamination.testSelections &&
                    posturalExamination.testSelections.length > 0
                      ? posturalExamination.testSelections[0]
                      : undefined
                  }
                  setTestSelection={setTestSelection}
                  allInOneLine={false}
                  allowMultiSelection={true}
                />
              )}
            </Col>
            <Col span={11}>
              {testDefinitions.length > 1 && (
                <TestUI
                  testDefinition={
                    testDefinitions.length > 1 ? testDefinitions[1] : undefined
                  }
                  testSelection={
                    posturalExamination.testSelections &&
                    posturalExamination.testSelections.length > 1
                      ? posturalExamination.testSelections[1]
                      : undefined
                  }
                  setTestSelection={setTestSelection}
                  allInOneLine={false}
                  allowMultiSelection={true}
                />
              )}
            </Col>
            <Col span={2}></Col>
            <Col span={11}>
              {testDefinitions.length > 2 && (
                <TestUI
                  testDefinition={
                    testDefinitions.length > 2 ? testDefinitions[2] : undefined
                  }
                  testSelection={
                    posturalExamination.testSelections &&
                    posturalExamination.testSelections.length > 2
                      ? posturalExamination.testSelections[2]
                      : undefined
                  }
                  setTestSelection={setTestSelection}
                  allInOneLine={false}
                  allowMultiSelection={true}
                />
              )}
            </Col>
            <Col span={24}>
              {testDefinitions.length > 3 && (
                <TestUI
                  testDefinition={
                    testDefinitions.length > 3 ? testDefinitions[3] : undefined
                  }
                  testSelection={
                    posturalExamination.testSelections &&
                    posturalExamination.testSelections.length > 3
                      ? posturalExamination.testSelections[3]
                      : undefined
                  }
                  setTestSelection={setTestSelection}
                  allInOneLine={false}
                  allowMultiSelection={true}
                />
              )}
            </Col>
          </Row>
        </>
      )}
      {page == 2 && (
        <>
          {testDefinitions.length > 4 && (
            <TestUIStim
              testDefinitions={
                testDefinitions.length > 5
                  ? [testDefinitions[5], testDefinitions[4]]
                  : undefined
              }
              testSelections={
                posturalExamination.testSelections &&
                posturalExamination.testSelections.length > 5
                  ? [
                      posturalExamination.testSelections[5],
                      posturalExamination.testSelections[4],
                    ]
                  : undefined
              }
              setTestSelection={setTestSelection}
            />
          )}
        </>
      )}
    </>
  );
};

export default PosturalExamPodoStimRight;
